import * as z from "zod";
import {
  MAX_EXECUTION_RETENTION_SECONDS,
  MIN_EXECUTION_RETENTION_SECONDS,
} from "../executionRetention";
import { mutator } from "./mutator";

export const setWorkflowRetention = mutator({
  schema: z.object({
    workflowId: z.string(),
    retentionSeconds: z
      .number()
      .int()
      .min(MIN_EXECUTION_RETENTION_SECONDS)
      .max(MAX_EXECUTION_RETENTION_SECONDS),
  }),
  resolve: {
    workflow: { kind: "workflow", from: "workflowId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  fn: async ({ tx, args: { workflow, retentionSeconds } }) => {
    await tx.mutate.workflows.update({
      id: workflow.id,
      retentionSeconds,
      updatedAt: Date.now(),
    });
  },
});
